<script setup>
import { defineProps, computed } from "vue"
import Meta from "./Meta.vue"
import Breadcrumb from "@common/js/utils/Breadcrumb.vue"

//props
const props = defineProps({
  entry: {
    type: Object,
    required: true,
  },
})

// computed
const seriesTag = computed(() => {
  const entryTags = props.entry.metadata.tags.map((o) => o.sys.id)

  if (entryTags.includes("installationSteps"))
    return {
      title: "Comment faire ?",
      to: { name: "BlogSeries", query: { series: "installationSteps" } },
    }
  else if (entryTags.includes("introductions"))
    return {
      title: "Guide solaire",
      to: { name: "BlogSeries", query: { series: "introductions" } },
    }
  else if (entryTags.includes("stories"))
    return {
      title: "Témoignages",
      to: { name: "BlogSeries", query: { series: "stories" } },
    }
  else
    return {
      title: "Articles",
      to: { name: "BlogSeries" },
    }
})

const pages = computed(() => [
  {
    name: "Renseignements",
    to: { name: "BlogHome" },
  },
  {
    name: seriesTag.value.title,
    to: seriesTag.value.to,
  },
])
</script>

<template>
  <div class="max-w-7xl mx-auto md:pb-12 relative">
    <div class="hero-theme">
      <Breadcrumb :pages="pages" class="mb-4 pb-4" divider="slash" />
      <!-- Main container -->
      <div
        class="flex md:h-[30rem] justify-center items-stretch flex-col md:flex-row relative"
      >
        <!-- Left section -->
        <div class="flex flex-col md:pr-12 md:mr-6 w-full md:w-[80%]">
          <!-- Title and optional description -->
          <h1 class="text-3xl font-bold text-gray-900 mb-8">
            {{ entry.fields.title }}
          </h1>
          <p v-if="entry.fields.description" class="text-gray-700 mb-12">
            {{ entry.fields.description }}
          </p>

          <!-- Meta component -->
          <Meta v-if="entry.fields.author" :entry="entry" />
        </div>

        <!-- Right section -->
        <div v-if="entry.fields.heroImage" class="w-full md:w-1/2">
          <img
            :src="'https://' + entry.fields.heroImage.fields.file.url"
            :alt="entry.fields.title"
            class="object-cover w-full h-full rounded-lg"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.hero-theme::before {
  background: theme("colors.orange.100");
  content: "";
  height: 80%;
  left: 64%;
  pointer-events: none;
  position: absolute;
  border-radius: 10px;
  top: 16%;
  width: 38%;
  z-index: -1;
}
@media only screen and (max-width: 768px) {
  .hero-theme::before {
    display: none;
  }
}
</style>
